module.exports = __webpack_public_path__ + "img/product-banner-icon.10d6f925.png";